import React from "react";
import { Loader2 } from "lucide-react";
import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "./ui/accordion";
import { FAQ as FAQ_TID } from "../constants/testIds";
import { useContent } from "../hooks/useContent";

const FAQ = () => {
    const { data, isLoading } = useContent("faq");
    const content = data?.data || {};
    const items = content.items || [];

    return (
        <section id="faq" data-testid={FAQ_TID.section} className="relative py-24 md:py-32 bg-white">
            <div className="max-w-3xl mx-auto px-6 md:px-10">
                <div className="text-center">
                    <div className="dp-eyebrow">{content.eyebrow || "FAQ"}</div>
                    <h2 className="mt-3 font-display text-4xl md:text-5xl tracking-tight font-light text-neutral-900 leading-[1.05]">
                        {content.title || "Questions fréquentes."}
                    </h2>
                    <p className="mt-4 text-[16px] text-neutral-500">
                        {content.subtitle || "Tout ce qu'il faut savoir avant votre première commande."}
                    </p>
                </div>

                {isLoading && (
                    <div className="mt-16 flex justify-center">
                        <Loader2 className="w-8 h-8 animate-spin text-[#0a84ff]" />
                    </div>
                )}

                <Accordion
                    type="single"
                    collapsible
                    className="mt-12 divide-y divide-black/[0.06] border-y border-black/[0.06]"
                >
                    {items.map((it, i) => (
                        <AccordionItem
                            key={i}
                            value={`item-${i}`}
                            data-testid={FAQ_TID.item(i)}
                            className="border-0"
                        >
                            <AccordionTrigger className="text-left font-display text-[17px] md:text-[18px] tracking-tight font-medium text-neutral-900 hover:no-underline py-6">
                                <span className="flex items-start gap-4">
                                    <span className="font-mono-tech text-[11px] text-[#0a84ff] mt-1.5 shrink-0">
                                        {String(i + 1).padStart(2, "0")}
                                    </span>
                                    {it.question}
                                </span>
                            </AccordionTrigger>
                            <AccordionContent className="text-[15px] leading-relaxed text-neutral-500 pb-6 pl-9">
                                {it.answer}
                            </AccordionContent>
                        </AccordionItem>
                    ))}
                </Accordion>
            </div>
        </section>
    );
};

export default FAQ;
